var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAddImageIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M5 21q-.824 0-1.413-.587A1.93 1.93 0 0 1 3 19V5q0-.824.587-1.413A1.93 1.93 0 0 1 5 3h14q.824 0 1.413.587.586.589.587 1.413v14q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M5 19h14V5H5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M6 17h12l-3.75-5-3 4L9 13zm2.5-7q.624 0 1.063-.438Q10 9.125 10 8.5q0-.624-.438-1.063A1.45 1.45 0 0 0 8.5 7q-.624 0-1.063.438A1.45 1.45 0 0 0 7 8.5q0 .624.438 1.063Q7.875 10 8.5 10"
}))));
export default SvgAddImageIcon;